var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          staticClass: "pt-5 pt-md-9 pb-2",
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "router-link",
            {
              staticClass: "d-flex align-center text-decoration-none",
              attrs: {
                to: {
                  name: "hosting_cpanel_info",
                  params: {
                    id: _vm.$route.params.id
                  },
                  query: {
                    user: _vm.$route.query.user
                  }
                }
              }
            },
            [
              _c(
                "v-icon",
                {
                  attrs: {
                    size: "20"
                  }
                },
                [_vm._v("mdi-keyboard-backspace")]
              ),
              _vm._v(" Go back to managing " + _vm._s(_vm.hosting.domain) + " ")
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "div",
            [
              _vm.missinghistory || _vm.hasInvoice
                ? _c(
                    "div",
                    [
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasInvoice,
                              expression: "hasInvoice"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            " This service has an open invoice. Please contact Sales for assistance with your request. "
                          )
                        ]
                      ),
                      _c(
                        "p",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.missinghistory,
                              expression: "missinghistory"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            " Your account needs to be reviewed by our team before your plan can be changed. You can speak to one of our 24/7 live chat agents to assist you. "
                          )
                        ]
                      ),
                      _c(
                        "gg-btn",
                        {
                          on: {
                            click: _vm.prefillAndOpenChat
                          }
                        },
                        [_vm._v(" Speak to 24/7 Live Agent ")]
                      )
                    ],
                    1
                  )
                : _c(
                    "v-item-group",
                    {
                      attrs: {
                        mandatory: ""
                      },
                      model: {
                        value: _vm.selected,
                        callback: function callback($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        _vm._l(_vm.items, function(item, i) {
                          return _c(
                            "v-col",
                            {
                              key: i,
                              attrs: {
                                cols: "12",
                                md: "3"
                              }
                            },
                            [
                              _c("v-item", {
                                attrs: {
                                  value: item.key
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function fn(_ref) {
                                        var active = _ref.active,
                                          toggle = _ref.toggle
                                        return [
                                          _c(
                                            "v-card",
                                            {
                                              staticClass: "app-card",
                                              on: {
                                                click: toggle
                                              }
                                            },
                                            [
                                              _c(
                                                "v-card-text",
                                                {
                                                  staticClass:
                                                    "text-center pa-0",
                                                  style: active
                                                    ? "border: 2px solid #0ca750 !important"
                                                    : "border: 2px solid rgba(0, 0, 0, 0.12) !important"
                                                },
                                                [
                                                  item.current
                                                    ? _c(
                                                        "v-chip",
                                                        {
                                                          staticClass:
                                                            "current-plan",
                                                          attrs: {
                                                            color: "primary",
                                                            "x-small": ""
                                                          }
                                                        },
                                                        [_vm._v("Current Plan")]
                                                      )
                                                    : _vm._e(),
                                                  item.promotion
                                                    ? _c(
                                                        "v-tooltip",
                                                        {
                                                          attrs: {
                                                            bottom: "",
                                                            color: "primary",
                                                            "max-width": "300",
                                                            "content-class":
                                                              "opacity-100"
                                                          },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key:
                                                                  "activator",
                                                                fn: function fn(
                                                                  _ref2
                                                                ) {
                                                                  var on =
                                                                      _ref2.on,
                                                                    attrs =
                                                                      _ref2.attrs
                                                                  return [
                                                                    _c(
                                                                      "v-chip",
                                                                      _vm._g(
                                                                        {
                                                                          staticClass:
                                                                            "current-plan",
                                                                          attrs: {
                                                                            color:
                                                                              "primary",
                                                                            "x-small":
                                                                              ""
                                                                          }
                                                                        },
                                                                        on
                                                                      ),
                                                                      [
                                                                        _c(
                                                                          "v-icon",
                                                                          {
                                                                            attrs: {
                                                                              size:
                                                                                "14",
                                                                              color:
                                                                                "#ffd859"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "mdi-star"
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticStyle: {
                                                                              padding:
                                                                                "1px 0 0 3px"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "On Sale"
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              }
                                                            ],
                                                            null,
                                                            true
                                                          )
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-flex flex-column justify-space-between"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "font-weight-bold text-center"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.promotion_name
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "text-center"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.promotion_description
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "h2",
                                                    {
                                                      staticClass: "pt-10 pb-10"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(item.name) +
                                                          " "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            size: "medium"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.iconFlag(
                                                                  item.flag
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  !item.isCurrent &&
                                                  !item.promotion
                                                    ? _c("div", [
                                                        _c(
                                                          "h3",
                                                          {
                                                            staticClass:
                                                              "pb-1 mb-0"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.moneyFormat(
                                                                    item.price_monthly
                                                                  )
                                                                ) +
                                                                "/month "
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "mb-3 d-block"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Renewal price " +
                                                                _vm._s(
                                                                  _vm.moneyFormat(
                                                                    item.price_renewal_monthly
                                                                  )
                                                                ) +
                                                                "/month "
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    : !item.promotion
                                                    ? _c(
                                                        "h3",
                                                        {
                                                          staticClass: "pb-4"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.moneyFormat(
                                                                  _vm.filterPrice(
                                                                    item.selectedTerm,
                                                                    item
                                                                  )
                                                                )
                                                              ) +
                                                              "/month "
                                                          )
                                                        ]
                                                      )
                                                    : _c(
                                                        "h3",
                                                        {
                                                          staticClass: "pb-4"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.pricePromotion(
                                                                  item
                                                                )
                                                              ) +
                                                              _vm._s(
                                                                item.promotion_type ==
                                                                  "monthly"
                                                                  ? "/month"
                                                                  : " today"
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      ),
                                                  _c(
                                                    "gg-btn",
                                                    {
                                                      staticClass: "mb-4",
                                                      attrs: {
                                                        color: !active
                                                          ? "primary"
                                                          : _vm.$vuetify.theme
                                                              .dark
                                                          ? "light"
                                                          : "white",
                                                        large: "",
                                                        tile: "",
                                                        href: item.url,
                                                        target: "_blank"
                                                      },
                                                      on: {
                                                        click: toggle
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "show",
                                                              rawName: "v-show",
                                                              value: active,
                                                              expression:
                                                                "active"
                                                            }
                                                          ],
                                                          attrs: {
                                                            small: ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-check-bold"
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " Select" +
                                                          _vm._s(
                                                            active ? "ed" : ""
                                                          ) +
                                                          " Plan "
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  item.features
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  item.features
                                                                    .inherits
                                                                    .length > 0,
                                                                expression:
                                                                  "item.features.inherits.length > 0"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "mb-3 text-left mx-4 body-2"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Includes everything in " +
                                                                _vm._s(
                                                                  []
                                                                    .concat(
                                                                      item
                                                                        .features
                                                                        .inherits,
                                                                      [""]
                                                                    )
                                                                    .toString()
                                                                    .replace(
                                                                      ",",
                                                                      ", "
                                                                    )
                                                                ) +
                                                                " plus: "
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  item.features
                                                                    .features
                                                                    .length > 0,
                                                                expression:
                                                                  "item.features.features.length > 0"
                                                              }
                                                            ],
                                                            staticClass: "mb-6"
                                                          },
                                                          [
                                                            _c(
                                                              "ul",
                                                              {
                                                                staticClass:
                                                                  "text-left list-unstyled mx-4"
                                                              },
                                                              _vm._l(
                                                                item.features
                                                                  .features,
                                                                function(
                                                                  feature,
                                                                  fi
                                                                ) {
                                                                  return _c(
                                                                    "li",
                                                                    {
                                                                      key: "feature".concat(
                                                                        fi
                                                                      ),
                                                                      staticClass:
                                                                        "subtitle-1"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            feature
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ]
      ),
      _vm.selectedPlan && !_vm.hasInvoice && !_vm.missinghistory
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12"
              }
            },
            [
              _c("plan-details-card", {
                attrs: {
                  "selected-plan": _vm.selectedPlan,
                  "current-plan": _vm.currentPlan,
                  "time-left": _vm.timeLeft,
                  "renewal-date": _vm.renewalDate,
                  "money-format": _vm.moneyFormat
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.selectedPlan && !_vm.hasInvoice && !_vm.missinghistory
        ? _c(
            "v-col",
            {
              attrs: {
                cols: "12",
                lg: "4",
                md: "6"
              }
            },
            [
              !_vm.selectedPlan.current
                ? [
                    _c(
                      "gg-card",
                      {
                        staticClass: "mb-4"
                      },
                      [
                        _c("gg-card-header", [_vm._v(" Payment Summary ")]),
                        _c(
                          "gg-card-text",
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "h4 font-weight-regular",
                                    attrs: {
                                      cols: "6"
                                    }
                                  },
                                  [_vm._v("Upgrade Price")]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "justify-end",
                                    attrs: {
                                      cols: "6",
                                      md: "4"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-right h4 font-weight-regular"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.moneyFormat(
                                              _vm.selectedPlan.price
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "h4 font-weight-bold",
                                    attrs: {
                                      cols: "6"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.selectedPlan.credit > 0
                                            ? "Credit Owed"
                                            : "Total Due"
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "justify-end",
                                    attrs: {
                                      cols: "6",
                                      md: "4"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-right h4 font-weight-bold"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.moneyFormat(
                                                _vm.selectedPlan.credit ||
                                                  _vm.selectedPlan.price
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    !_vm.selectedPlan.credit
                      ? _c(
                          "gg-card",
                          [
                            _c("gg-card-header", [_vm._v(" Payment Method ")]),
                            _c(
                              "gg-card-text",
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        attrs: {
                                          cols: "12"
                                        }
                                      },
                                      [
                                        _c("payment-gateway", {
                                          ref: "paymentGateway",
                                          staticClass: "mt-4",
                                          attrs: {
                                            "no-padding": "",
                                            "card-select": "",
                                            "card-type":
                                              _vm.SessionProfile.card_type,
                                            toolbar: false,
                                            paypal: false,
                                            compact: true,
                                            "card-selection-label":
                                              "Select Card"
                                          },
                                          on: {
                                            card: _vm.listenCard,
                                            "card-switch": _vm.listenCardNew
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "v-row",
                      {
                        staticClass: "mt-0"
                      },
                      [
                        _vm.term
                          ? _c(
                              "v-col",
                              {
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("v-checkbox", {
                                  staticClass: "mt-2",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function fn() {
                                          return [
                                            _c(
                                              "div",
                                              [
                                                _vm._v(
                                                  " I confirm that I wish to change my hosting plan to the selection made above and have read and understood the "
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      bottom: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function fn(
                                                            _ref3
                                                          ) {
                                                            var on = _ref3.on
                                                            return [
                                                              _c(
                                                                "a",
                                                                _vm._g(
                                                                  {
                                                                    attrs: {
                                                                      target:
                                                                        "_blank",
                                                                      href:
                                                                        "https://www.greengeeks.com/legal/tos"
                                                                    },
                                                                    on: {
                                                                      click: function click(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                      }
                                                                    }
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    " Terms of Service "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      2399260985
                                                    )
                                                  },
                                                  [_vm._v(" Open in new tab ")]
                                                ),
                                                _vm._v(
                                                  " and have acknowledged the receipt of the "
                                                ),
                                                _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: {
                                                      bottom: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function fn(
                                                            _ref4
                                                          ) {
                                                            var on = _ref4.on
                                                            return [
                                                              _c(
                                                                "a",
                                                                _vm._g(
                                                                  {
                                                                    attrs: {
                                                                      target:
                                                                        "_blank",
                                                                      href:
                                                                        "https://www.greengeeks.com/legal/privacy"
                                                                    },
                                                                    on: {
                                                                      click: function click(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                      }
                                                                    }
                                                                  },
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    " Privacy Policy "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      724164760
                                                    )
                                                  },
                                                  [_vm._v(" Open in new tab ")]
                                                ),
                                                _vm._v(
                                                  ". All changes are effective immediately unless otherwise specified. "
                                                )
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    false,
                                    1987660528
                                  ),
                                  model: {
                                    value: _vm.agreeCheckbox,
                                    callback: function callback($$v) {
                                      _vm.agreeCheckbox = $$v
                                    },
                                    expression: "agreeCheckbox"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              cols: "12"
                            }
                          },
                          [
                            _c(
                              "gg-btn",
                              {
                                attrs: {
                                  disabled: !_vm.agreeCheckbox,
                                  loading: _vm.requestLoading
                                },
                                on: {
                                  click: _vm.sendRequest
                                }
                              },
                              [_vm._v(" Change Plan ")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }